// historialEquipos.js
import React, { useState, useEffect, useRef } from 'react';
import { Link, useParams } from 'react-router-dom';
import { useQuery } from '@apollo/react-hooks';
import gql from 'graphql-tag';
import HistorialIcon from './icons/historial';
import DeleteButton from './deleteAndLikes/deleteButomTrainedHistorial';
import Verdetalle from './detalleEquipos';
import './historial.css';
import useClickOutside from './modulos-propios/useClickOutside';

const FETCH_POSTS_QUERY_USER_LINK = gql`
  query getUsersEquiposCreados($username: String!) {
    getUsersEquiposCreados(username: $username) {
      id
      nombres
      informacion
      createdAt
    }
  }
`;

const FETCH_EQUIPOS_CREADOS_QUERY = gql`
  query($username: String!) {
    getUsersEquiposCreados(username: $username) {
      id
      nombres
      informacion
      createdAt
    }
  }
`;

function FilteredPosts({ refetch, user }) {
  const username = (user || '').replace(/[^a-zA-Z0-9]/g, '');
  const { postId } = useParams();

  const [showDropdown, setShowDropdown] = useState(false);
  const [dropdownStates, setDropdownStates] = useState({});
  const dropdownRefs = useRef({});
  const [isModalDetalleOpen, setIsModalDetalleOpen] = useState(false);

  useClickOutside(showDropdown, setShowDropdown);

  const { loading, error, data, refetch: queryRefetch } = useQuery(
    FETCH_POSTS_QUERY_USER_LINK,
    { variables: { username }, skip: !username }
  );

  // Re-fetch externo
  useEffect(() => {
    if (refetch) {
      queryRefetch();
    }
  }, [refetch, queryRefetch]);

  // Cerrar dropdown si se hace click fuera
  useEffect(() => {
    const handleClickOutside = (event) => {
      Object.keys(dropdownRefs.current).forEach((key) => {
        if (
          dropdownRefs.current[key] &&
          !dropdownRefs.current[key].contains(event.target)
        ) {
          setDropdownStates((prevState) => ({ ...prevState, [key]: false }));
        }
      });
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  const handleDropdownToggle = (id) => {
    setDropdownStates((prev) => ({ ...prev, [id]: !prev[id] }));
  };

  if (loading) {
    return (
      <div className="spinner-container">
        <div className="spinner">
          <img src="/images/logo512.png" alt="loading" />
        </div>
      </div>
    );
  }

  if (error) {
    return <p>Error: {error.message}</p>;
  }

  // Lista continua SIN paginación temporal, ordenada por fecha desc (igual a historialRecto)
  const posts = (data?.getUsersEquiposCreados || [])
    .slice()
    .sort(
      (a, b) =>
        new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime()
    );

  return (
    <div className="historial-wrapper">
      <div className="posts-container fade-bottom">
        {posts.map((post, index) => {
          const isActive = String(post.id) === String(postId);
          const text =
            (post.nombres || '').length > 19
              ? post.nombres.substring(0, 19).toLowerCase() + '..'
              : (post.nombres || '').toLowerCase();

          // Opacidad suave por índice (igual estilo que historialRecto)
          const opacity = Math.max(0.35, 1 - index * 0.015);

          return (
            <div
              key={post.id}
              className="post-item"
              style={{ opacity }}
              ref={(el) => (dropdownRefs.current[post.id] = el)}
            >
              <Link
                to={`/estadoEquipo/${post.id}`}
                className={['post-link', isActive ? 'active' : ''].join(' ')}
                title={post.nombres}
              >
                <HistorialIcon size={13} />
                {' ' + text}
                <span className="created-at">
                  {new Date(post.createdAt).toLocaleString()}
                </span>
              </Link>

            

             
            </div>
          );
        })}
      </div>
    </div>
  );
}

export default FilteredPosts;

